export default __webpack_public_path__ + "static/media/card4.d5bbd171.png";